import React, { Component } from "react";
import bowser from "bowser";
import { Provider } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { ThemeProvider } from "styled-components";
import {
  MobileMediaQuery,
  UnsupportedBrowser,
  materialUITheme,
  styledComponentTheme
} from "ui-components";

import store from "@store";
import AppRoutes from "@common/AppRoutes";

class AppContent extends Component {
  render() {
    // Ensure browser is supported
    //  Only works for IE 9 & 10 (all other versions caught by conditionals)
    if (!bowser.check({ msie: "11", msedge: "11" })) {
      return <UnsupportedBrowser />;
    }

    return (
      <MuiThemeProvider muiTheme={materialUITheme}>
        <ThemeProvider theme={styledComponentTheme}>
          <MobileMediaQuery>
            <Provider store={store}>
              <Router>
                <AppRoutes />
              </Router>
            </Provider>
          </MobileMediaQuery>
        </ThemeProvider>
      </MuiThemeProvider>
    );
  }
}

export default AppContent;



// WEBPACK FOOTER //
// ./src/App.jsx